import React from 'react';
import Icon from "@mui/material/Icon";
import Logout from "@mui/icons-material/Logout";
import Blog from "@mui/icons-material/Newspaper";
import Person from "@mui/icons-material/Person";
import PersonSearch from "@mui/icons-material/PersonSearch";
import Info from "@mui/icons-material/InfoOutlined";
import LogOut from "./pages/LandingPages/LogOut/LogOut";

const routes = [
  {
    name: <span style={{ fontWeight: 'bold' }}>Home</span>,
    name: "Home",
    icon: <Icon>home</Icon>,
    route: "/app/trainingcompanydashboard",
  },
  {
    name: <span style={{ fontWeight: 'bold' }}>Create Training</span>,
    name: "Create Training",
    icon: <Blog />,
    route: "/app/trainingpost",
  },
  {
    name: <span style={{ fontWeight: 'bold' }}>Edit Profile</span>,
    name: "Edit Profile",
    icon: <Person />,
    route: `/app/trainingcompanyprofileedit/${localStorage.getItem("userId")}`,
  },
  {
    name: <span style={{ fontWeight: 'bold' }}>Trainers</span>,
    name: "Trainers",
    icon: <PersonSearch />,
    route: "/app/trainerlistindex",
  },
  {
    name: <span style={{ fontWeight: 'bold' }}>Pending Actions</span>,
    name: "Pending Actions",
    icon: <Info />,
    route: "/app/trainingcompanypendingaction",
  },
  {
    name: "LogOut",
    route: "/app/logout",
    component: <LogOut />,
    icon: <Logout />,
  },
];

export default routes;
